import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider as JotaiProvider } from 'jotai';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import bugsnag from './bugsnag';
import ErrorAlert from 'components/error_alert';
import '@ant-design/v5-patch-for-react-19';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const bugsnagClient = bugsnag();

const ErrorBoundary = bugsnagClient?.createErrorBoundary(React);

const ErrorView = () => (
  <ErrorAlert message="We encountered an unexpected error. Please try again later" />
);

const children = (
  <BrowserRouter>
    <JotaiProvider>
      <App />
    </JotaiProvider>
  </BrowserRouter>
);

root.render(
  // <React.StrictMode>
  // TODO: The application doesn't work properly when strict mode is on. Which according
  // to the documentation is a sign of architecture level issues. For example, the
  // useEffect for the survey_page executes twice and creates two interactions.
  // Perhaps creating the interaction on page load is not a good idea. Perhaps we
  // should keep some kind of state so that we know we shouln't create a new interaction. Etc.
  // Let's discuss.

  ErrorBoundary
    ? (
        <ErrorBoundary FallbackComponent={ErrorView}>{children}</ErrorBoundary>
      )
    : (
        children
      ),
  // </React.StrictMode>
);
